export default "__VITE_ASSET__KNe6KzPX__"